import { Public, ProtectedRoute, PrivilegedRoute } from '@middlewares';

import Eventos from '@pages/Events/Eventos';
import PreguntasPost from '@pages/Events/PreguntasPost';
import Invitados from '@pages/Events/Invitados';
import InvitadosEvent from '@pages/Events/InvitadosEvent';
import Staff from '@pages/Events/Staff';
import StaffEvent from '@pages/Events/StaffEvent';
import EventosPaseLista from '@pages/Events/EventosPaseLista';
import EventosPaseListaInfo from '@pages/Events/EventosPaseListaInfo';
import PreRegistro from '@pages/Events/PreRegistro';
import Dashboard from '@pages/Events/Dashboard';
import Noticias from '@pages/Noticias/Noticias';
import Publicaciones from '@pages/Foca/Publicaciones';
import Estructura from '@pages/Foca/Estructura';
import Banner from '@pages/Ppm/Banner';

import { PAGINA_FOCA } from '@data/constants/Noticias';
import { ID_FOCA } from '@data/constants/Eventos';
import TemplatesQR from '@pages/Events/TemplatesQR';

const FocaRoutes = [
  {
    path: '/foca/eventos',
    element: <PrivilegedRoute title="Eventos" page={<Eventos idTipoEvento={ID_FOCA} id="foca" />} />,
  },
  {
    path: '/foca/eventos/preguntas',
    element: <ProtectedRoute title="Preguntas" page={<PreguntasPost idTipoEvento={ID_FOCA} id="foca" />} />,
  },
  {
    path: '/foca/eventos/invitados',
    element: <PrivilegedRoute title="Invitados" page={<Invitados idTipoEvento={ID_FOCA} id="foca" />} />,
  },
  {
    path: '/foca/eventos/invitados/:id',
    element: <ProtectedRoute title="Invitados" page={<InvitadosEvent />} />,
  },
  {
    path: '/foca/eventos/staff',
    element: <PrivilegedRoute title="Staff" page={<Staff idTipoEvento={ID_FOCA} id="foca" />} />,
  },
  {
    path: '/foca/eventos/staff/:id',
    element: <ProtectedRoute title="Staff" page={<StaffEvent />} />,
  },
  {
    path: '/foca/eventos/pase-lista',
    element: <PrivilegedRoute title="Pase de lista" page={<EventosPaseLista idTipoEvento={ID_FOCA} />} />,
  },
  {
    path: '/foca/eventos/pase-lista/:id',
    element: <ProtectedRoute title="Pase de lista" page={<EventosPaseListaInfo />} />,
  },
  {
    path: '/foca/noticias',
    element: <PrivilegedRoute title="Noticias" page={<Noticias page={PAGINA_FOCA} />} />,
  },
  {
    path: '/foca/publicaciones',
    element: <PrivilegedRoute title="Publicaciones" page={<Publicaciones id="foca" />} />,
  },
  {
    path: '/foca/eventos/dashboard/:id',
    element: <ProtectedRoute title="Dashboard" page={<Dashboard />} />,
  },
  {
    path: 'foca/eventos/preregistro/:id',
    element: <Public title="Preregistro" page={<PreRegistro idTipoEvento={ID_FOCA} />} />,
  },
  {
    path: 'foca/estructura',
    element: <PrivilegedRoute title="Estructura" page={<Estructura />} />,
  },
  {
    path: '/foca/banner',
    element: <PrivilegedRoute title="Banner" page={<Banner id="foca" />} />,
  },
  {
    path: '/foca/plantillas',
    element: <ProtectedRoute title="Registro Plantillas" page={<TemplatesQR idTipo={2} />} />,
  },
];

export default FocaRoutes;
